import { Select, Textarea, TextInput } from "../../common";

type RateCodingEntry = {
  id?: string | null;
  tempId: string;
  version: string;
  isActive: string;
  structuredEncodingJson: string;
  naturalLanguageEncoding: string;
  fromTemplateId: string;
  notes: string;
};

interface NodeRateCodingFormProps {
  kind: string;
  index: number;
  entry: any;
  handleRateCodingChange: (
    kind: string,
    index: number,
    field: keyof RateCodingEntry,
    value: string
  ) => void;
}

const NodeRateCodingForm = (props: NodeRateCodingFormProps) => {
  const { kind, index, entry, handleRateCodingChange } = props;
  return (
    <tr className="node-ratecoding-table__editor">
      <td colSpan={6}>
        <div className="node-ratecoding-card">
          <div className="synapse-entity-modal__fieldset node-ratecoding-card__grid">
            <TextInput
              id={`${kind}-ratecoding-${index}-version`}
              name="version"
              type="number"
              value={entry.version}
              onChange={(event) =>
                handleRateCodingChange(
                  kind,
                  index,
                  "version",
                  event.target.value
                )
              }
              placeholder="1"
              variant="modal"
              label="Version"
              hint="Optional integer version."
            />
            <Select
              id={`${kind}-ratecoding-${index}-isActive`}
              name="isActive"
              value={entry.isActive}
              onChange={(event) =>
                handleRateCodingChange(
                  kind,
                  index,
                  "isActive",
                  event.target.value
                )
              }
              variant="modal"
              options={[
                { value: "true", label: "Active" },
                { value: "false", label: "Inactive" },
              ]}
              label="Status"
              placeholder=""
            />
          </div>
          <div className="synapse-entity-modal__form-group">
            <Textarea
              id={`${kind}-ratecoding-${index}-structuredEncoding`}
              name="structuredEncodingJson"
              rows={6}
              value={entry.structuredEncodingJson}
              onChange={(event) =>
                handleRateCodingChange(
                  kind,
                  index,
                  "structuredEncodingJson",
                  event.target.value
                )
              }
              placeholder='{"mapping": {"node": "..."}}'
              variant="modal"
              label="Structured mapping (JSON)"
              hint="Exact JSON stored for this relevance scoring row."
            />
          </div>
          <div className="synapse-entity-modal__form-group">
            <Textarea
              id={`${kind}-ratecoding-${index}-naturalLanguage`}
              name="naturalLanguageEncoding"
              rows={4}
              value={entry.naturalLanguageEncoding}
              onChange={(event) =>
                handleRateCodingChange(
                  kind,
                  index,
                  "naturalLanguageEncoding",
                  event.target.value
                )
              }
              placeholder="Describe the mapping in natural language"
              variant="modal"
              label="Natural language mapping"
            />
          </div>
          <div className="synapse-entity-modal__fieldset node-ratecoding-card__grid">
            <TextInput
              id={`${kind}-ratecoding-${index}-fromTemplate`}
              name="fromTemplateId"
              type="text"
              value={entry.fromTemplateId}
              onChange={(event) =>
                handleRateCodingChange(
                  kind,
                  index,
                  "fromTemplateId",
                  event.target.value
                )
              }
              placeholder="Template UUID"
              variant="modal"
              label="Template ID"
              hint="Optional reference to template source."
            />
            <Textarea
              id={`${kind}-ratecoding-${index}-notes`}
              name="notes"
              rows={3}
              value={entry.notes}
              onChange={(event) =>
                handleRateCodingChange(kind, index, "notes", event.target.value)
              }
              placeholder="Add reviewer notes or annotations"
              variant="modal"
              label="Notes"
            />
          </div>
        </div>
      </td>
    </tr>
  );
};

export default NodeRateCodingForm;
